import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {
  constructor(private _elementRef: ElementRef) {
  }

  @Output()
  public appClickOutside = new EventEmitter();

  @HostListener('document:click', ['$event'])
  public onClick(event: PointerEvent) {
    const targetElement = <HTMLElement>(event.target);
    const clickedInside = this._elementRef.nativeElement.contains(targetElement)
      || targetElement.id === 'messageToggle'
      || targetElement.id === 'messageToggleIcon'
      || targetElement.getAttribute('name') === 'messageClose';
    if (!clickedInside) {
      this.appClickOutside.emit(null);
    }
  }
}
